import { PropagateLoader } from 'react-spinners';

export default function Loader({ label, style }) {
  return (
    <div className="card" style={{ textAlign: 'center', padding: '2.5rem 1rem', ...style }}>
      <PropagateLoader color="var(--sea)" size={13} />
      {label && <div style={{ marginTop: '1.1rem', color: 'var(--slate)', fontSize: 'var(--text-sm)' }}>{label}</div>}
    </div>
  );
}
